import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const prorideeldConfig: TSPConfig = {
  key: 'prorideeld',
  name: 'ProRideELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from ProRideELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[
        { name: 'apikey', label: 'API Key', type: 'text', required: true },
      ]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default prorideeldConfig;
